import Cookies from 'js-cookie';

const languageKey = '_lang';
export const getLanguage = () => Cookies.get(languageKey);
export const setLanguage = (language: string) => Cookies.set(languageKey, language);

const authTokenKey = 'authToken';
export const getAuthToken = () => Cookies.get(authTokenKey);
export const setAuthToken = (authToken: string) => Cookies.set(authTokenKey, authToken);

const uuidKey = 'uuid';
export const getUserId = () => Cookies.get(uuidKey);
export const setUserId = (uuid: string) => Cookies.set(uuidKey, uuid);

const userNameKey = 'username';
export const getUserName = () => Cookies.get(userNameKey);
export const setUserName = (userName: string) => Cookies.set(userNameKey, userName);
